// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file knowledge/knowledge.proto (package lvdr.v2.knowledge, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Sensitivity } from "../common/sensitivity_pb";
import { file_common_sensitivity } from "../common/sensitivity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file knowledge/knowledge.proto.
 */
export const file_knowledge_knowledge: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_sensitivity]);

/**
 * @generated from message lvdr.v2.knowledge.KnowledgeNodeProto
 */
export type KnowledgeNodeProto = Message<"lvdr.v2.knowledge.KnowledgeNodeProto"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string wing = 4;
   */
  wing: string;

  /**
   * @generated from field: string room = 5;
   */
  room: string;

  /**
   * @generated from field: string hall = 6;
   */
  hall: string;

  /**
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * @generated from field: repeated string aliases = 8;
   */
  aliases: string[];

  /**
   * @generated from field: string description = 9;
   */
  description: string;

  /**
   * @generated from field: string summary = 10;
   */
  summary: string;

  /**
   * @generated from field: double confidence = 11;
   */
  confidence: number;

  /**
   * @generated from field: int32 importance = 12;
   */
  importance: number;

  /**
   * @generated from field: string tier = 13;
   */
  tier: string;

  /**
   * @generated from field: int32 mentions = 14;
   */
  mentions: number;

  /**
   * @generated from field: lvdr.v2.knowledge.TrustProfileProto trust = 15;
   */
  trust?: TrustProfileProto | undefined;

  /**
   * @generated from field: repeated string tags = 16;
   */
  tags: string[];

  /**
   * @generated from field: repeated lvdr.v2.knowledge.EvidenceProto evidence = 17;
   */
  evidence: EvidenceProto[];

  /**
   * @generated from field: lvdr.v2.knowledge.SourceProto source = 18;
   */
  source?: SourceProto | undefined;

  /**
   * @generated from field: int64 created_at = 19;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 20;
   */
  updatedAt: bigint;

  /**
   * Sensitivity gates outbound LLM/voice traffic. See common/sensitivity.proto.
   *
   * @generated from field: lvdr.v2.common.Sensitivity sensitivity = 21;
   */
  sensitivity: Sensitivity;
};

/**
 * Describes the message lvdr.v2.knowledge.KnowledgeNodeProto.
 * Use `create(KnowledgeNodeProtoSchema)` to create a new message.
 */
export const KnowledgeNodeProtoSchema: GenMessage<KnowledgeNodeProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 0);

/**
 * @generated from message lvdr.v2.knowledge.TrustProfileProto
 */
export type TrustProfileProto = Message<"lvdr.v2.knowledge.TrustProfileProto"> & {
  /**
   * @generated from field: string source_tier = 1;
   */
  sourceTier: string;

  /**
   * @generated from field: string evidence_grade = 2;
   */
  evidenceGrade: string;

  /**
   * @generated from field: double reliability = 3;
   */
  reliability: number;

  /**
   * @generated from field: repeated lvdr.v2.knowledge.BiasSignalProto bias_signals = 4;
   */
  biasSignals: BiasSignalProto[];

  /**
   * @generated from field: string sentiment = 5;
   */
  sentiment: string;

  /**
   * @generated from field: string certainty = 6;
   */
  certainty: string;

  /**
   * @generated from field: int32 corroboration = 7;
   */
  corroboration: number;

  /**
   * @generated from field: int32 contradictions = 8;
   */
  contradictions: number;

  /**
   * @generated from field: bool contentious = 9;
   */
  contentious: boolean;
};

/**
 * Describes the message lvdr.v2.knowledge.TrustProfileProto.
 * Use `create(TrustProfileProtoSchema)` to create a new message.
 */
export const TrustProfileProtoSchema: GenMessage<TrustProfileProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 1);

/**
 * @generated from message lvdr.v2.knowledge.BiasSignalProto
 */
export type BiasSignalProto = Message<"lvdr.v2.knowledge.BiasSignalProto"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: string indicator = 3;
   */
  indicator: string;
};

/**
 * Describes the message lvdr.v2.knowledge.BiasSignalProto.
 * Use `create(BiasSignalProtoSchema)` to create a new message.
 */
export const BiasSignalProtoSchema: GenMessage<BiasSignalProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 2);

/**
 * @generated from message lvdr.v2.knowledge.EvidenceProto
 */
export type EvidenceProto = Message<"lvdr.v2.knowledge.EvidenceProto"> & {
  /**
   * @generated from field: string source_id = 1;
   */
  sourceId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string snippet = 3;
   */
  snippet: string;
};

/**
 * Describes the message lvdr.v2.knowledge.EvidenceProto.
 * Use `create(EvidenceProtoSchema)` to create a new message.
 */
export const EvidenceProtoSchema: GenMessage<EvidenceProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 3);

/**
 * @generated from message lvdr.v2.knowledge.SourceProto
 */
export type SourceProto = Message<"lvdr.v2.knowledge.SourceProto"> & {
  /**
   * @generated from field: string source_type = 1;
   */
  sourceType: string;

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * @generated from field: string research_id = 3;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.SourceProto.
 * Use `create(SourceProtoSchema)` to create a new message.
 */
export const SourceProtoSchema: GenMessage<SourceProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 4);

/**
 * @generated from message lvdr.v2.knowledge.ScoredNodeProto
 */
export type ScoredNodeProto = Message<"lvdr.v2.knowledge.ScoredNodeProto"> & {
  /**
   * @generated from field: lvdr.v2.knowledge.KnowledgeNodeProto node = 1;
   */
  node?: KnowledgeNodeProto | undefined;

  /**
   * @generated from field: double score = 2;
   */
  score: number;
};

/**
 * Describes the message lvdr.v2.knowledge.ScoredNodeProto.
 * Use `create(ScoredNodeProtoSchema)` to create a new message.
 */
export const ScoredNodeProtoSchema: GenMessage<ScoredNodeProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 5);

/**
 * @generated from message lvdr.v2.knowledge.KnowledgeEdgeProto
 */
export type KnowledgeEdgeProto = Message<"lvdr.v2.knowledge.KnowledgeEdgeProto"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId: string;

  /**
   * @generated from field: string target_id = 3;
   */
  targetId: string;

  /**
   * @generated from field: string relation = 4;
   */
  relation: string;

  /**
   * @generated from field: double weight = 5;
   */
  weight: number;
};

/**
 * Describes the message lvdr.v2.knowledge.KnowledgeEdgeProto.
 * Use `create(KnowledgeEdgeProtoSchema)` to create a new message.
 */
export const KnowledgeEdgeProtoSchema: GenMessage<KnowledgeEdgeProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 6);

/**
 * @generated from message lvdr.v2.knowledge.SearchKnowledgeRequest
 */
export type SearchKnowledgeRequest = Message<"lvdr.v2.knowledge.SearchKnowledgeRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string wing = 2;
   */
  wing: string;

  /**
   * @generated from field: string room = 3;
   */
  room: string;

  /**
   * @generated from field: string hall = 4;
   */
  hall: string;

  /**
   * @generated from field: repeated string kinds = 5;
   */
  kinds: string[];

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: int32 top_k = 7;
   */
  topK: number;

  /**
   * @generated from field: int32 graph_depth = 8;
   */
  graphDepth: number;

  /**
   * search research node outputs
   *
   * @generated from field: bool deep_search = 9;
   */
  deepSearch: boolean;

  /**
   * search raw searcher evidence
   *
   * @generated from field: bool include_raw_sources = 10;
   */
  includeRawSources: boolean;
};

/**
 * Describes the message lvdr.v2.knowledge.SearchKnowledgeRequest.
 * Use `create(SearchKnowledgeRequestSchema)` to create a new message.
 */
export const SearchKnowledgeRequestSchema: GenMessage<SearchKnowledgeRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 7);

/**
 * @generated from message lvdr.v2.knowledge.SearchKnowledgeResponse
 */
export type SearchKnowledgeResponse = Message<"lvdr.v2.knowledge.SearchKnowledgeResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.knowledge.ScoredNodeProto results = 1;
   */
  results: ScoredNodeProto[];

  /**
   * @generated from field: int32 bm25_hits = 2;
   */
  bm25Hits: number;

  /**
   * @generated from field: int32 vector_hits = 3;
   */
  vectorHits: number;

  /**
   * @generated from field: int32 fused_hits = 4;
   */
  fusedHits: number;

  /**
   * @generated from field: int32 filtered = 5;
   */
  filtered: number;

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeEdgeProto edges = 6;
   */
  edges: KnowledgeEdgeProto[];

  /**
   * @generated from field: int32 deep_search_hits = 7;
   */
  deepSearchHits: number;

  /**
   * @generated from field: int32 raw_source_hits = 8;
   */
  rawSourceHits: number;
};

/**
 * Describes the message lvdr.v2.knowledge.SearchKnowledgeResponse.
 * Use `create(SearchKnowledgeResponseSchema)` to create a new message.
 */
export const SearchKnowledgeResponseSchema: GenMessage<SearchKnowledgeResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 8);

/**
 * Progress event streamed during deep search as each research is searched.
 *
 * @generated from message lvdr.v2.knowledge.KnowledgeSearchProgressEvent
 */
export type KnowledgeSearchProgressEvent = Message<"lvdr.v2.knowledge.KnowledgeSearchProgressEvent"> & {
  /**
   * @generated from field: int32 research_total = 1;
   */
  researchTotal: number;

  /**
   * @generated from field: int32 research_searched = 2;
   */
  researchSearched: number;

  /**
   * @generated from field: int32 deep_hits_so_far = 3;
   */
  deepHitsSoFar: number;

  /**
   * @generated from field: int32 raw_source_hits_so_far = 4;
   */
  rawSourceHitsSoFar: number;

  /**
   * @generated from field: string current_research = 5;
   */
  currentResearch: string;
};

/**
 * Describes the message lvdr.v2.knowledge.KnowledgeSearchProgressEvent.
 * Use `create(KnowledgeSearchProgressEventSchema)` to create a new message.
 */
export const KnowledgeSearchProgressEventSchema: GenMessage<KnowledgeSearchProgressEvent> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 9);

/**
 * @generated from message lvdr.v2.knowledge.BrowseKnowledgeRequest
 */
export type BrowseKnowledgeRequest = Message<"lvdr.v2.knowledge.BrowseKnowledgeRequest"> & {
  /**
   * @generated from field: string wing = 1;
   */
  wing: string;

  /**
   * @generated from field: string room = 2;
   */
  room: string;

  /**
   * @generated from field: string hall = 3;
   */
  hall: string;

  /**
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;
};

/**
 * Describes the message lvdr.v2.knowledge.BrowseKnowledgeRequest.
 * Use `create(BrowseKnowledgeRequestSchema)` to create a new message.
 */
export const BrowseKnowledgeRequestSchema: GenMessage<BrowseKnowledgeRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 10);

/**
 * @generated from message lvdr.v2.knowledge.WingSummary
 */
export type WingSummary = Message<"lvdr.v2.knowledge.WingSummary"> & {
  /**
   * @generated from field: string wing = 1;
   */
  wing: string;

  /**
   * @generated from field: int32 node_count = 2;
   */
  nodeCount: number;

  /**
   * @generated from field: repeated string rooms = 3;
   */
  rooms: string[];
};

/**
 * Describes the message lvdr.v2.knowledge.WingSummary.
 * Use `create(WingSummarySchema)` to create a new message.
 */
export const WingSummarySchema: GenMessage<WingSummary> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 11);

/**
 * @generated from message lvdr.v2.knowledge.BrowseKnowledgeResponse
 */
export type BrowseKnowledgeResponse = Message<"lvdr.v2.knowledge.BrowseKnowledgeResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.knowledge.WingSummary wings = 1;
   */
  wings: WingSummary[];

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeNodeProto nodes = 2;
   */
  nodes: KnowledgeNodeProto[];

  /**
   * @generated from field: int32 total = 3;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.knowledge.BrowseKnowledgeResponse.
 * Use `create(BrowseKnowledgeResponseSchema)` to create a new message.
 */
export const BrowseKnowledgeResponseSchema: GenMessage<BrowseKnowledgeResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 12);

/**
 * @generated from message lvdr.v2.knowledge.ListKnowledgeGapsRequest
 */
export type ListKnowledgeGapsRequest = Message<"lvdr.v2.knowledge.ListKnowledgeGapsRequest"> & {
  /**
   * @generated from field: int32 min_hit_count = 1;
   */
  minHitCount: number;
};

/**
 * Describes the message lvdr.v2.knowledge.ListKnowledgeGapsRequest.
 * Use `create(ListKnowledgeGapsRequestSchema)` to create a new message.
 */
export const ListKnowledgeGapsRequestSchema: GenMessage<ListKnowledgeGapsRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 13);

/**
 * @generated from message lvdr.v2.knowledge.KnowledgeGapProto
 */
export type KnowledgeGapProto = Message<"lvdr.v2.knowledge.KnowledgeGapProto"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string wing = 2;
   */
  wing: string;

  /**
   * @generated from field: int32 hit_count = 3;
   */
  hitCount: number;

  /**
   * @generated from field: int64 last_seen = 4;
   */
  lastSeen: bigint;
};

/**
 * Describes the message lvdr.v2.knowledge.KnowledgeGapProto.
 * Use `create(KnowledgeGapProtoSchema)` to create a new message.
 */
export const KnowledgeGapProtoSchema: GenMessage<KnowledgeGapProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 14);

/**
 * @generated from message lvdr.v2.knowledge.ListKnowledgeGapsResponse
 */
export type ListKnowledgeGapsResponse = Message<"lvdr.v2.knowledge.ListKnowledgeGapsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeGapProto gaps = 1;
   */
  gaps: KnowledgeGapProto[];
};

/**
 * Describes the message lvdr.v2.knowledge.ListKnowledgeGapsResponse.
 * Use `create(ListKnowledgeGapsResponseSchema)` to create a new message.
 */
export const ListKnowledgeGapsResponseSchema: GenMessage<ListKnowledgeGapsResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 15);

/**
 * @generated from message lvdr.v2.knowledge.GetKnowledgeNodeRequest
 */
export type GetKnowledgeNodeRequest = Message<"lvdr.v2.knowledge.GetKnowledgeNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.GetKnowledgeNodeRequest.
 * Use `create(GetKnowledgeNodeRequestSchema)` to create a new message.
 */
export const GetKnowledgeNodeRequestSchema: GenMessage<GetKnowledgeNodeRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 16);

/**
 * @generated from message lvdr.v2.knowledge.GetKnowledgeNodeResponse
 */
export type GetKnowledgeNodeResponse = Message<"lvdr.v2.knowledge.GetKnowledgeNodeResponse"> & {
  /**
   * @generated from field: lvdr.v2.knowledge.KnowledgeNodeProto node = 1;
   */
  node?: KnowledgeNodeProto | undefined;

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeEdgeProto edges = 2;
   */
  edges: KnowledgeEdgeProto[];

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeNodeProto related = 3;
   */
  related: KnowledgeNodeProto[];
};

/**
 * Describes the message lvdr.v2.knowledge.GetKnowledgeNodeResponse.
 * Use `create(GetKnowledgeNodeResponseSchema)` to create a new message.
 */
export const GetKnowledgeNodeResponseSchema: GenMessage<GetKnowledgeNodeResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 17);

/**
 * @generated from message lvdr.v2.knowledge.UpdateKnowledgeNodeRequest
 */
export type UpdateKnowledgeNodeRequest = Message<"lvdr.v2.knowledge.UpdateKnowledgeNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string wing = 4;
   */
  wing: string;

  /**
   * @generated from field: string room = 5;
   */
  room: string;

  /**
   * @generated from field: string hall = 6;
   */
  hall: string;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * Sensitivity update. `optional` so that an absent field means "leave
   * unchanged" — explicit PUBLIC is a legitimate downgrade and reaches the
   * handler as a non-nil pointer with value 0. Same convention as memory and
   * document UpdateXxxRequests.
   *
   * @generated from field: optional lvdr.v2.common.Sensitivity sensitivity = 8;
   */
  sensitivity?: Sensitivity | undefined;
};

/**
 * Describes the message lvdr.v2.knowledge.UpdateKnowledgeNodeRequest.
 * Use `create(UpdateKnowledgeNodeRequestSchema)` to create a new message.
 */
export const UpdateKnowledgeNodeRequestSchema: GenMessage<UpdateKnowledgeNodeRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 18);

/**
 * @generated from message lvdr.v2.knowledge.UpdateKnowledgeNodeResponse
 */
export type UpdateKnowledgeNodeResponse = Message<"lvdr.v2.knowledge.UpdateKnowledgeNodeResponse"> & {
  /**
   * @generated from field: lvdr.v2.knowledge.KnowledgeNodeProto node = 1;
   */
  node?: KnowledgeNodeProto | undefined;
};

/**
 * Describes the message lvdr.v2.knowledge.UpdateKnowledgeNodeResponse.
 * Use `create(UpdateKnowledgeNodeResponseSchema)` to create a new message.
 */
export const UpdateKnowledgeNodeResponseSchema: GenMessage<UpdateKnowledgeNodeResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 19);

/**
 * @generated from message lvdr.v2.knowledge.DeleteKnowledgeNodeRequest
 */
export type DeleteKnowledgeNodeRequest = Message<"lvdr.v2.knowledge.DeleteKnowledgeNodeRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.DeleteKnowledgeNodeRequest.
 * Use `create(DeleteKnowledgeNodeRequestSchema)` to create a new message.
 */
export const DeleteKnowledgeNodeRequestSchema: GenMessage<DeleteKnowledgeNodeRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 20);

/**
 * @generated from message lvdr.v2.knowledge.DeleteKnowledgeNodeResponse
 */
export type DeleteKnowledgeNodeResponse = Message<"lvdr.v2.knowledge.DeleteKnowledgeNodeResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * The node that was deleted. Added by RT-01: without it the frontend
   * correlated deletes by popping the first id off a pending set, which is
   * order-dependent and mis-attributes the splice whenever a prior delete
   * errored (no response) or two deletes are in flight.
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.DeleteKnowledgeNodeResponse.
 * Use `create(DeleteKnowledgeNodeResponseSchema)` to create a new message.
 */
export const DeleteKnowledgeNodeResponseSchema: GenMessage<DeleteKnowledgeNodeResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 21);

/**
 * KnowledgeChangedEvent announces that the owner's knowledge base changed and an
 * open view should refresh. Pushed UNSOLICITED across instances by the realtime
 * fan-out hub, for changes the receiving client did not make: an edit in another
 * tab or on another device, and cascade extraction absorbing a research pass.
 *
 * Deliberately NOT a re-use of Update/DeleteKnowledgeNodeResponse. Those are
 * request-correlated on the client — the delete handler pops a pending id — so
 * an unsolicited one would splice the wrong node and close the open detail
 * panel. A distinct "something changed, refresh" event also collapses N node
 * writes from one extraction pass into one client refresh instead of N upserts.
 *
 * @generated from message lvdr.v2.knowledge.KnowledgeChangedEvent
 */
export type KnowledgeChangedEvent = Message<"lvdr.v2.knowledge.KnowledgeChangedEvent"> & {
  /**
   * "updated" | "deleted" | "extracted"
   *
   * @generated from field: string change_type = 1;
   */
  changeType: string;

  /**
   * set for single-node changes; empty for a batch
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * nodes touched (1 for a single-node change)
   *
   * @generated from field: int32 node_count = 3;
   */
  nodeCount: number;
};

/**
 * Describes the message lvdr.v2.knowledge.KnowledgeChangedEvent.
 * Use `create(KnowledgeChangedEventSchema)` to create a new message.
 */
export const KnowledgeChangedEventSchema: GenMessage<KnowledgeChangedEvent> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 22);

/**
 * @generated from message lvdr.v2.knowledge.GetNodeUsageRequest
 */
export type GetNodeUsageRequest = Message<"lvdr.v2.knowledge.GetNodeUsageRequest"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.GetNodeUsageRequest.
 * Use `create(GetNodeUsageRequestSchema)` to create a new message.
 */
export const GetNodeUsageRequestSchema: GenMessage<GetNodeUsageRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 23);

/**
 * @generated from message lvdr.v2.knowledge.NodeUsageProto
 */
export type NodeUsageProto = Message<"lvdr.v2.knowledge.NodeUsageProto"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * "chat" | "voice" | "research"
   *
   * @generated from field: string surface = 2;
   */
  surface: string;

  /**
   * chat session id / voice session id / research id
   *
   * @generated from field: string context_id = 3;
   */
  contextId: string;

  /**
   * human-readable context name (length-capped)
   *
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * turns within this context the node grounded
   *
   * @generated from field: int32 count = 5;
   */
  count: number;

  /**
   * unix seconds
   *
   * @generated from field: int64 first_used_at = 6;
   */
  firstUsedAt: bigint;

  /**
   * unix seconds
   *
   * @generated from field: int64 last_used_at = 7;
   */
  lastUsedAt: bigint;
};

/**
 * Describes the message lvdr.v2.knowledge.NodeUsageProto.
 * Use `create(NodeUsageProtoSchema)` to create a new message.
 */
export const NodeUsageProtoSchema: GenMessage<NodeUsageProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 24);

/**
 * @generated from message lvdr.v2.knowledge.NodeUsageSummaryProto
 */
export type NodeUsageSummaryProto = Message<"lvdr.v2.knowledge.NodeUsageSummaryProto"> & {
  /**
   * distinct chat+voice contexts
   *
   * @generated from field: int32 conversations = 1;
   */
  conversations: number;

  /**
   * distinct research contexts
   *
   * @generated from field: int32 researches = 2;
   */
  researches: number;

  /**
   * sum of count across rows
   *
   * @generated from field: int32 total_turns = 3;
   */
  totalTurns: number;

  /**
   * unix seconds
   *
   * @generated from field: int64 last_used_at = 4;
   */
  lastUsedAt: bigint;
};

/**
 * Describes the message lvdr.v2.knowledge.NodeUsageSummaryProto.
 * Use `create(NodeUsageSummaryProtoSchema)` to create a new message.
 */
export const NodeUsageSummaryProtoSchema: GenMessage<NodeUsageSummaryProto> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 25);

/**
 * @generated from message lvdr.v2.knowledge.GetNodeUsageResponse
 */
export type GetNodeUsageResponse = Message<"lvdr.v2.knowledge.GetNodeUsageResponse"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: lvdr.v2.knowledge.NodeUsageSummaryProto summary = 2;
   */
  summary?: NodeUsageSummaryProto | undefined;

  /**
   * most-recent first
   *
   * @generated from field: repeated lvdr.v2.knowledge.NodeUsageProto usages = 3;
   */
  usages: NodeUsageProto[];

  /**
   * tracking_enabled is false when LVDR_KNOWLEDGE_USAGE_TRACKING_ENABLED is off
   * — the FE then shows "usage tracking disabled" instead of an empty state that
   * reads like "never used".
   *
   * @generated from field: bool tracking_enabled = 4;
   */
  trackingEnabled: boolean;
};

/**
 * Describes the message lvdr.v2.knowledge.GetNodeUsageResponse.
 * Use `create(GetNodeUsageResponseSchema)` to create a new message.
 */
export const GetNodeUsageResponseSchema: GenMessage<GetNodeUsageResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 26);

/**
 * @generated from message lvdr.v2.knowledge.SearchResearchContextRequest
 */
export type SearchResearchContextRequest = Message<"lvdr.v2.knowledge.SearchResearchContextRequest"> & {
  /**
   * required — the research whose store to search
   *
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * free-text query
   *
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * max results, 0 = default 20
   *
   * @generated from field: int32 top_k = 3;
   */
  topK: number;

  /**
   * filter by node kind ("concept", "entity"); empty = all
   *
   * @generated from field: repeated string kinds = 4;
   */
  kinds: string[];
};

/**
 * Describes the message lvdr.v2.knowledge.SearchResearchContextRequest.
 * Use `create(SearchResearchContextRequestSchema)` to create a new message.
 */
export const SearchResearchContextRequestSchema: GenMessage<SearchResearchContextRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 27);

/**
 * @generated from message lvdr.v2.knowledge.SearchResearchContextResponse
 */
export type SearchResearchContextResponse = Message<"lvdr.v2.knowledge.SearchResearchContextResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeNodeProto nodes = 1;
   */
  nodes: KnowledgeNodeProto[];

  /**
   * before top_k truncation
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.knowledge.SearchResearchContextResponse.
 * Use `create(SearchResearchContextResponseSchema)` to create a new message.
 */
export const SearchResearchContextResponseSchema: GenMessage<SearchResearchContextResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 28);

/**
 * @generated from message lvdr.v2.knowledge.BrowseResearchContextRequest
 */
export type BrowseResearchContextRequest = Message<"lvdr.v2.knowledge.BrowseResearchContextRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * empty = all kinds
   *
   * @generated from field: repeated string kinds = 2;
   */
  kinds: string[];

  /**
   * 0 = default 100
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message lvdr.v2.knowledge.BrowseResearchContextRequest.
 * Use `create(BrowseResearchContextRequestSchema)` to create a new message.
 */
export const BrowseResearchContextRequestSchema: GenMessage<BrowseResearchContextRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 29);

/**
 * @generated from message lvdr.v2.knowledge.BrowseResearchContextResponse
 */
export type BrowseResearchContextResponse = Message<"lvdr.v2.knowledge.BrowseResearchContextResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeNodeProto nodes = 1;
   */
  nodes: KnowledgeNodeProto[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.knowledge.BrowseResearchContextResponse.
 * Use `create(BrowseResearchContextResponseSchema)` to create a new message.
 */
export const BrowseResearchContextResponseSchema: GenMessage<BrowseResearchContextResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 30);

/**
 * @generated from message lvdr.v2.knowledge.ResearchNodeDetailRequest
 */
export type ResearchNodeDetailRequest = Message<"lvdr.v2.knowledge.ResearchNodeDetailRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * the KnowledgeNode.ID
   *
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.knowledge.ResearchNodeDetailRequest.
 * Use `create(ResearchNodeDetailRequestSchema)` to create a new message.
 */
export const ResearchNodeDetailRequestSchema: GenMessage<ResearchNodeDetailRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 31);

/**
 * @generated from message lvdr.v2.knowledge.ResearchNodeDetailResponse
 */
export type ResearchNodeDetailResponse = Message<"lvdr.v2.knowledge.ResearchNodeDetailResponse"> & {
  /**
   * @generated from field: lvdr.v2.knowledge.KnowledgeNodeProto node = 1;
   */
  node?: KnowledgeNodeProto | undefined;

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeEdgeProto edges = 2;
   */
  edges: KnowledgeEdgeProto[];

  /**
   * @generated from field: repeated lvdr.v2.knowledge.KnowledgeNodeProto neighbors = 3;
   */
  neighbors: KnowledgeNodeProto[];
};

/**
 * Describes the message lvdr.v2.knowledge.ResearchNodeDetailResponse.
 * Use `create(ResearchNodeDetailResponseSchema)` to create a new message.
 */
export const ResearchNodeDetailResponseSchema: GenMessage<ResearchNodeDetailResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 32);

/**
 * Promote selected research-context nodes into the user's knowledge.Store.
 * Palace wing/hall/room and trust assessment are applied at commit time.
 * Idempotent via knowledge.Store.UpsertNode merge-on-write.
 *
 * @generated from message lvdr.v2.knowledge.PromoteResearchContextRequest
 */
export type PromoteResearchContextRequest = Message<"lvdr.v2.knowledge.PromoteResearchContextRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * KnowledgeNode IDs to promote
   *
   * @generated from field: repeated string node_ids = 2;
   */
  nodeIds: string[];
};

/**
 * Describes the message lvdr.v2.knowledge.PromoteResearchContextRequest.
 * Use `create(PromoteResearchContextRequestSchema)` to create a new message.
 */
export const PromoteResearchContextRequestSchema: GenMessage<PromoteResearchContextRequest> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 33);

/**
 * @generated from message lvdr.v2.knowledge.PromoteResearchContextResponse
 */
export type PromoteResearchContextResponse = Message<"lvdr.v2.knowledge.PromoteResearchContextResponse"> & {
  /**
   * @generated from field: int32 committed = 1;
   */
  committed: number;

  /**
   * @generated from field: int32 skipped = 2;
   */
  skipped: number;

  /**
   * @generated from field: int32 edges_committed = 3;
   */
  edgesCommitted: number;

  /**
   * for frontend toast/feedback
   *
   * @generated from field: repeated string committed_ids = 4;
   */
  committedIds: string[];

  /**
   * @generated from field: repeated string skipped_ids = 5;
   */
  skippedIds: string[];
};

/**
 * Describes the message lvdr.v2.knowledge.PromoteResearchContextResponse.
 * Use `create(PromoteResearchContextResponseSchema)` to create a new message.
 */
export const PromoteResearchContextResponseSchema: GenMessage<PromoteResearchContextResponse> = /*@__PURE__*/
  messageDesc(file_knowledge_knowledge, 34);

